import Big from 'big.js'
import {memo} from 'react'

import Price from '@/components/Price'
import {USD_DISPLAY_DECIMALS} from '@/constants/config'
import type {FoodProduct} from '@/lib/food/foodModel'

import type {Customization, FoodItem} from './types'
import {getCustomizationText} from './utils'

interface MobileItemLayoutProps {
  item: FoodItem
  productDetails?: FoodProduct | null
  styles: {
    MobileItemHeader: string
    MobileItemImage: string
    MobileItemImagePlaceholder: string
    MobileItemContent: string
    MobileItemNameAndQuantity: string
    MobileItemName: string
    MobileItemQuantity: string
    MobileItemDetails: string
    MobileItemPrice: string
    MobileItemCustomizations: string
  }
}

export default memo(function MobileItemLayout({
  item,
  productDetails,
  styles
}: MobileItemLayoutProps) {
  const imageUrl: string | null | undefined = productDetails?.image ?? productDetails?.thumbnail_image
  const customizations: string = getCustomizationText((item.customizations ?? []) as Customization[])

  return (
    <div className={styles.MobileItemHeader}>
      <div className={styles.MobileItemImage}>
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt={item.name}
            loading="lazy"
            onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
              const target = e.target as HTMLImageElement
              target.style.display = 'none'
              const placeholder = target.parentElement?.querySelector(`.${styles.MobileItemImagePlaceholder}`)
              if (placeholder) (placeholder as HTMLElement).style.display = 'flex'
            }}
          />
        ) : null}
        <div 
          className={styles.MobileItemImagePlaceholder}
          style={{ display: imageUrl ? 'none' : 'flex' }}
        >
          🍽️
        </div>
      </div>
      
      <div className={styles.MobileItemContent}>
        <div className={styles.MobileItemNameAndQuantity}>
          <span className={styles.MobileItemName}>{item.name}</span>
          <span className={styles.MobileItemQuantity}>x {item.quantity}</span>
        </div>
        
        <div className={styles.MobileItemDetails}>
          <div className={styles.MobileItemPrice}>
            <Price 
              price={Big(item.basePrice)} 
              options={{ fractionDigits: USD_DISPLAY_DECIMALS, exactFractionDigits: true }}
            />
          </div>
          {customizations && (
            <div className={styles.MobileItemCustomizations}>
              {customizations}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}) 